
        var result = require("!!../extract-text-webpack-plugin/loader.js??ref--13-0!../css-loader/index.js!../postcss-loader/index.js??ref--13-2!../sass-loader/index.js??ref--13-3!../sass-resources-loader/lib/loader.js??ref--13-4!../import-glob-loader/index.js!./angular-material.scss");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./~/angular-material/angular-material.scss
// module id = 2073
// module chunks = 0